import React from 'react'
import styled from 'styled-components'
import { above, secondary, LargeP } from '../elements'

import consumer from '../images/industry/consumer-goods-icon.svg'
import paperpackage from '../images/industry/paper-packaging-icon.svg'
import manufacturing from '../images/industry/manufacturing-icon.svg'
import retail from '../images/industry/retail-icon.svg'
import foodbeverage from '../images/industry/food-beverage-icon.svg'
import frozen from '../images/industry/frozen-icon.svg'
import nursery from '../images/industry/nursery-icon.svg'
import technology from '../images/industry/technology-icon.svg'

const Industries = () => (
  <Zone>
    <h2>Industries</h2>
    <LightLargeP>
      D&D is committed to providing the best transportation experience in the
      industry. We have a fleet with experienced drivers, dedicated to the safe
      delivery of your freight. Since 1980, we have served a wide variety of
      industries.
    </LightLargeP>
    <List>
      <Item>
        <IndustryIcon src={frozen} alt="Frozen and Chilled Goods" />
        <h5>Frozen & Chilled</h5>
      </Item>
      <Item>
        <IndustryIcon src={consumer} alt="Consumer Goods" />
        <h5>Consumer Goods</h5>
      </Item>
      <Item>
        <IndustryIcon src={retail} alt="Retail and Dry Goods" />
        <h5>Retail & Dry Goods</h5>
      </Item>
      <Item>
        <IndustryIcon src={paperpackage} alt="Paper and Packaging" />
        <h5>Paper & Packaging</h5>
      </Item>
      <Item>
        <IndustryIcon src={manufacturing} alt="Manufacturing" />
        <h5>Manufacturing</h5>
      </Item>
      <Item>
        <IndustryIcon src={nursery} alt="Nursery and Seed" />
        <h5>Nursery & Seed</h5>
      </Item>
      <Item>
        <IndustryIcon src={foodbeverage} alt="Food and Beverage" />
        <h5>Food & Beverage</h5>
      </Item>

      <Item>
        <IndustryIcon src={technology} alt="Technology and High Profile" />
        <h5>High Profile</h5>
      </Item>
    </List>
  </Zone>
)

export default Industries

const IndustryIcon = styled.img`
  width: 64px;
  margin-bottom: 10px;
`
const List = styled.div`
  display: flex;
  flex-flow: row wrap;
  justify-content: space-evenly;
  align-content: flex-start;
  max-width: ${props => props.theme.sizes.maxWidth};
  margin: 0 auto;
`
const Item = styled.div`
  margin-top: 1rem;
  flex: 1 0 49%;
  ${above.lg`
    flex: 1 0 21%;
  `}
`
const LightLargeP = styled(LargeP)`
  color: white;
  max-width: ${props => props.theme.sizes.maxWidth};
  margin: 0 auto;
`
const Zone = styled.section`
  padding: 4rem 10%;
  color: white;
  position: relative;
  text-align: center;
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0.8;
    z-index: -1;
    transition: 0.3s all ease;
  }
  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: -2;
    background-size: cover;
    background: ${secondary};
  }
`
